import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import isEmail from 'validator/lib/isEmail';

import Button from 'components/Button';
import Modal from 'components/Modal';
import Row from 'components/Layout/Row';

const Contact = ({
  user,
  contactUs,
  closeModal,
  submitContact,
  feedbackSubmit,
}) => {
  const [input, setInput] = useState({
    subject: 'account-related',
    email: '',
    message: '',
  });
  const [sending, setSending] = useState(false);

  function inputHandler(e) {
    setInput({ ...input, [e.target.name]: e.target.value });
  }

  function submitHandler(e) {
    e.preventDefault();

    if (
      input.email.length > 0 &&
      isEmail(input.email) &&
      input.message.length > 0
    ) {
      setSending(true);
      if (input.subject === 'report-bug')
        feedbackSubmit({
          message: input.message,
          screenshots: [],
          isContact: true,
        });
      else submitContact(input);
    }
  }

  useEffect(() => {
    if (user)
      setInput((state) => ({
        ...state,
        email: user.email,
      }));
  }, [user]);

  useEffect(() => {
    if (contactUs.success) {
      setSending(false);
      setInput({ subject: '', email: user.email, message: '' });
    }
  }, [contactUs, user]);

  return (
    <Modal
      show={contactUs.showContactModal}
      toggleModal={closeModal}
      contentProps={{ style: { maxWidth: 467, padding: 30, height: 'auto' } }}>
      <h3 style={{ fontSize: 24, marginTop: 0 }}>Contact Us</h3>
      <form onSubmit={submitHandler} className="users-form smaller-labels">
        <div className="mb-2">
          <label htmlFor="contact-email">
            Email Address
            <br />
            <input
              type="email"
              name="email"
              id="contact-email"
              placeholder="Enter email address"
              value={input.email}
              disabled={input.email && input.email.length > 0}
              onChange={inputHandler}
              required
            />
          </label>
        </div>
        <div className="mb-2">
          <label className="custom-select" htmlFor="contact-subject">
            Subject
            <br />
            <select
              name="subject"
              id="contact-subject"
              value={input.subject}
              onChange={inputHandler}>
              <option value="account-related">Account related</option>
              <option value="upgrade-account">Upgrade account</option>
              <option value="report-bug">Report a bug</option>
              <option value="feature-request">Recommend a new feature</option>
              <option value="billing">Billing</option>
              <option value="sales">Sales</option>
              <option value="report-abuse">Report abuse</option>
              <option value="others">Something else</option>
            </select>
          </label>
        </div>
        <div className="mb-2">
          <label htmlFor="message">
            How can we help you?
            <br />
            <textarea
              name="message"
              id="message"
              placeholder="Enter your message"
              value={input.message}
              onChange={inputHandler}
              rows="5"
              required
            />
          </label>
        </div>
        <Row justify="space-between" style={{ margin: 0 }}>
          <Button
            type="submit"
            style={{ padding: '14px 40px', fontSize: 16 }}
            disabled={
              sending === true ||
              !input.message.trim().length ||
              !input.email.length ||
              !isEmail(input.email)
            }>
            {sending ? 'Sending...' : 'Submit'}
          </Button>
          <a
            href="https://ruttl.com/support/"
            target="_blank"
            rel="noopener noreferrer"
            className="link">
            Support doc
          </a>
        </Row>
      </form>
    </Modal>
  );
};

Contact.propTypes = {
  user: PropTypes.object,
  closeModal: PropTypes.func.isRequired,
  contactUs: PropTypes.object.isRequired,
  submitContact: PropTypes.func.isRequired,
  feedbackSubmit: PropTypes.func.isRequired,
};

export default Contact;
